/**
 * Where the session token lives. The web app supplies a browser implementation;
 * React Native apps supply one backed by the secure keychain. Methods may be async.
 */
export interface TokenStore {
  get(): string | null | Promise<string | null>;
  set(token: string): void | Promise<void>;
  clear(): void | Promise<void>;
}

/** Keeps the token in memory only. Used by tests and short-lived scripts. */
export class MemoryTokenStore implements TokenStore {
  private token: string | null;

  constructor(initial: string | null = null) {
    this.token = initial;
  }

  get() {
    return this.token;
  }

  set(token: string) {
    this.token = token;
  }

  clear() {
    this.token = null;
  }
}
